// ContraindicationsDialog.jsx (mobile-friendly)
import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export default function ExpressCareDialogInformation({
  open,
  onOpenChange,
  onProceed,
}) {
  const handleSelect = () => {
    onProceed?.();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl bg-white mt-6 sm:mt-0 max-h-[85vh]">
        <DialogBody className="space-y-6 max-h-[65vh] overflow-y-auto">
          {/* <h3 className="text-lg font-semibold">
            Pasirinkite dėl kokių nusiskundimų registruojatės
          </h3> */}
          <div className="mt-4 bg-[#F9FCFF] rounded-sm p-4">
            Express Care® by Affidea – tai operatyviai suteikiama medicininė
            pagalba, esant lengviems galūnių ir minkštųjų audinių sužalojimams.
          </div>
          <h3 className="text-lg font-semibold text-center">
            Daugiau informacijos
          </h3>
          <div className="space-y-4 bg-[#F9FCFF] rounded-sm p-4">
            Nereikėtų kreiptis į Express Care® šiais atvejais. Krūtinės
            skausmas, sunkios traumos, atviri lūžiai, sunkus dusulys, pilvo
            skausmas, su nėštumu susijusi liga, ginekologijos skundai.
          </div>

          <div className="space-y-4">
            Jei pasireiškė ūmios klinikinės būklės, kai gresia pavojus paciento
            ir (ar) aplinkinių gyvybei arba kai pagalbos nesuteikimas laiku
            sukeltų sunkių komplikacijų grėsmę pacientams.
            <strong>
              {' '}
              Šiais atvejais kuo skubiau skambinkite 112 arba kreipkitės į
              artimiausios ligoninės skubiosios pagalbos skyrių.
            </strong>{' '}
            Taip pat nereikėtų kreiptis, kai turite siuntimą gydytojo
            specialisto konsultacijai ir/ar tyrimui.
            <br />
            <strong>Pastaba:</strong>
            <br />
            Esant būtinybei gydytojas gali nukreipti pacientą į kitą gydymo
            įstaigą. Už Express Care® paslaugas galima atsiskaityti ir privačiu
            sveikatos draudimu. Dėl apmokėjimo privataus sveikatos draudimo
            lėšomis sąlygų maloniai kviečiame teirautis Jūsų draudimo atstovų.
          </div>
        </DialogBody>

        <DialogFooter>
          <Button variant="light" onClick={() => onOpenChange(false)}>
            Atšaukti
          </Button>
          <Button onClick={() => handleSelect()}>
            Supratau
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
